// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2suly","index":"styles_index__3KAB6"};